import { createTypes } from 'reduxsauce';

export default createTypes(
  `
    INSURANCE_COMPANIES_LIST_REQUEST
    INSURANCE_COMPANIES_LIST_REQUEST_SUCCESS
    INSURANCE_COMPANIES_LIST_REQUEST_ERROR

    CLEAR_STORE
  `,
  {
    prefix: '',
  }
);
